const HexagonalGrid = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Hexagonal grid pattern - simplified on mobile for performance */}
      <svg className="absolute inset-0 w-full h-full opacity-20 md:opacity-20" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="hexagons" width="100" height="87" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)">
            {/* Main hexagon */}
            <polygon
              points="50,0 93.3,25 93.3,62 50,87 6.7,62 6.7,25"
              fill="none"
              stroke="url(#neon-gradient)"
              strokeWidth="0.5"
              className="animate-pulse-subtle"
              style={{ animationDuration: '4s' }}
            />
            {/* Secondary hexagons for grid fill */}
            <polygon
              points="0,43.5 25,56.3 25,81.8 0,94.6 -25,81.8 -25,56.3"
              fill="none"
              stroke="url(#neon-gradient)"
              strokeWidth="0.5"
              opacity="0.6"
              className="animate-pulse-subtle"
              style={{ animationDuration: '5s', animationDelay: '1s' }}
            />
            <polygon
              points="100,43.5 125,56.3 125,81.8 100,94.6 75,81.8 75,56.3"
              fill="none"
              stroke="url(#neon-gradient)"
              strokeWidth="0.5"
              opacity="0.6"
              className="animate-pulse-subtle"
              style={{ animationDuration: '5s', animationDelay: '2s' }}
            />
          </pattern>
          
          {/* Neon gradient for grid lines */}
          <linearGradient id="neon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--holographic-cyan))" stopOpacity="0.8" />
            <stop offset="50%" stopColor="hsl(var(--holographic-pink))" stopOpacity="0.6" />
            <stop offset="100%" stopColor="hsl(var(--holographic-cyan))" stopOpacity="0.8" />
          </linearGradient>
          
          {/* Radial gradient for center glow */}
          <radialGradient id="center-glow">
            <stop offset="0%" stopColor="hsl(var(--holographic-cyan))" stopOpacity="0.15" />
            <stop offset="50%" stopColor="hsl(var(--holographic-pink))" stopOpacity="0.08" />
            <stop offset="100%" stopColor="transparent" stopOpacity="0" />
          </radialGradient>
        </defs>
        
        {/* Apply hexagonal pattern */}
        <rect width="100%" height="100%" fill="url(#hexagons)" />
        
        {/* Center glow effect */}
        <circle cx="50%" cy="50%" r="40%" fill="url(#center-glow)" />
      </svg>
      
      {/* Animated accent hexagons - hidden on mobile for performance */}
      <div className="hidden md:block absolute top-1/4 left-1/4 w-32 h-32 opacity-10">
        <svg viewBox="0 0 100 100" className="w-full h-full animate-spin-slow">
          <polygon
            points="50,5 90,30 90,70 50,95 10,70 10,30"
            fill="none"
            stroke="hsl(var(--holographic-cyan))"
            strokeWidth="1"
            className="animate-pulse-glow"
          />
        </svg>
      </div>
      
      <div className="hidden md:block absolute bottom-1/3 right-1/5 w-24 h-24 opacity-10">
        <svg viewBox="0 0 100 100" className="w-full h-full animate-spin-slow" style={{ animationDirection: 'reverse', animationDuration: '25s' }}>
          <polygon
            points="50,5 90,30 90,70 50,95 10,70 10,30"
            fill="none"
            stroke="hsl(var(--holographic-pink))"
            strokeWidth="1"
            className="animate-pulse-glow"
            style={{ animationDelay: '1s' }}
          />
        </svg>
      </div>
      
      {/* Scan line effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-holographic-cyan/5 to-transparent animate-scan-line opacity-30" />
    </div>
  );
};

export default HexagonalGrid;
